import React, { Component } from 'react'
import { toast } from 'react-toastify'
import $ from 'jquery'
// component
import Toaster from '../Toaster/Toaster'
import agent from '../../api/Api'
import { trackPageView, trackTimeSpent, trackFormConfusion, } from '../../utils/Analytics'
import config from '../../config/config'
// css
import './ChangePassword.css'

const FIELD_NAME_MAP = {
  currentPwd: 'current password',
  newPwd: 'new password', 
  confirmPwd: 'confirm password'
}

class ChangePassword extends Component {
  constructor (props) {
    super(props)
    this.state = {
      userInfo: {},
      currentPwd: '',
      currentPwdType: 'password',
      newPwd: '',
      newPwdType: 'password',
      confirmPwd: '',
      confirmPwdType: 'password',
      errorCount: {
        currentPwd: 0,
        newPwd: 0,
        confirmPwd: 0
      }
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleSubmitKeyPress = this.handleSubmitKeyPress.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handlePwdShowHide = this.handlePwdShowHide.bind(this)
    this.fieldTimers = {};
  }

  handlePwdShowHide (name, type) {
    console.log(name)
    this.setState({ [name]: type === 'password' ? 'text' : 'password' })
  }

  handleInputChange (event) {
    const { name, value } = event.target
    const analyticsName = FIELD_NAME_MAP[name] || name;
    this.setState({ [name]: value })
    if (value.length > 0) {
      $('#' + name).css({ border: '1px solid #ddd' })
    } else {
      $('#' + name).css({ border: '1px solid red' })
      this.setState(prev => ({
        errorCount: {
          ...prev.errorCount,
          [name]: (prev.errorCount[name] || 0) + 1
        }
      }), () => {
        if (this.state.errorCount[name] >= config.ERROR_COUNT) {
          trackFormConfusion('Change Password', analyticsName);
        }
      });
    }
  }

  handleFocus = (field) => {
    this.fieldTimers[field] = Date.now();
  };

  handleBlur = (field) => {
    if (this.fieldTimers[field]) {
      const duration = (Date.now() - this.fieldTimers[field]) / 1000;
      if (duration > config.FOCUS_TIME) {
        const analyticsName = FIELD_NAME_MAP[field] || field;
        trackFormConfusion('Change Password', analyticsName, duration);
      }
      delete this.fieldTimers[field];
    }
  };

  handleSubmit () {
    $('#loader').fadeIn()
    let param = {
      currentPwd: this.state.currentPwd,
      newPwd: this.state.newPwd,
      confirmPwd: this.state.confirmPwd
    }

    let count = 0
    for (var key in param) {
      if (param[key]) {
        $('#' + key).css({ border: '1px solid #ddd' })
        count += 1
      } else {
        $('#' + key).css({ border: '1px solid red' })
        const currentKey = key;
        const analyticsName = FIELD_NAME_MAP[currentKey] || currentKey;
        this.setState(prev => ({
          errorCount: {
            ...prev.errorCount,
            [currentKey]: (prev.errorCount[currentKey] || 0) + 1
          }
        }), () => {
          if (this.state.errorCount[currentKey] >= config.ERROR_COUNT) {
            trackFormConfusion('Change Password', analyticsName);
          }
        });
      }
    }

    if (param.currentPwd && param.newPwd && param.currentPwd === param.newPwd) {
      $('#loader').fadeOut()
      toast.dismiss()
      toast(<Toaster title='Change password' content='New and current password should not be same' status='error' />)

      this.setState(prev => ({
        errorCount: {
          ...prev.errorCount,
          currentPwd: (prev.errorCount.currentPwd || 0) + 1
        }
      }), () => {
        if (this.state.errorCount.currentPwd >= config.ERROR_COUNT) {
          trackFormConfusion('Change Password', 'current password');
        }
      });

      this.setState(prev => ({
        errorCount: {
          ...prev.errorCount,
          newPwd: (prev.errorCount.newPwd || 0) + 1
        }
      }), () => {
        if (this.state.errorCount.newPwd >= config.ERROR_COUNT) {
          trackFormConfusion('Change Password', 'new password');
        }
      });

      setTimeout(function () { toast.dismiss() }, 3000)
    } else if (param.newPwd !== param.confirmPwd) {
      $('#loader').fadeOut()
      toast.dismiss()
      toast(<Toaster title='Change password' content='New and confirm password not match' status='error' />)

       this.setState(prev => ({
        errorCount: {
          ...prev.errorCount,
          newPwd: (prev.errorCount.newPwd || 0) + 1
        }
      }), () => {
        if (this.state.errorCount.newPwd >= config.ERROR_COUNT) {
          trackFormConfusion('Change Password', 'new password');
        }
      });

      this.setState(prev => ({
        errorCount: {
          ...prev.errorCount,
          confirmPwd: (prev.errorCount.confirmPwd || 0) + 1
        }
      }), () => {
        if (this.state.errorCount.confirmPwd >= config.ERROR_COUNT) {
          trackFormConfusion('Change Password', 'confirm password');
        }
      });

      setTimeout(function () { toast.dismiss() }, 3000)
    }

    // alert(count)
    if (count === 3 && param.currentPwd !== param.newPwd && param.newPwd === param.confirmPwd) {
      var newParam = {
        email: this.state.userInfo.email,
        newPassword: param.newPwd,
        oldPassword: param.currentPwd
      }
      agent.APILIST.teacherSignin('/teacher/changePassword', newParam)
        .then(res => {
          if (res.status === 'SUCCESS') {
            $('#loader').fadeOut()
            this.props.hideOverlay()
            toast.dismiss()
            toast(<Toaster title='Teacher Login' content={res.message} status='error' />)
            setTimeout(function () { toast.dismiss() }, 3000)
          }
        })
        .catch(err => {
          let res = JSON.parse(err.response.text)
          toast.dismiss()
          toast(<Toaster title='Change password' content={res.message} status='error' />)
          setTimeout(function () { toast.dismiss() }, 3000)
          $('#loader').fadeOut()
        })
    }
  }

  handleSubmitKeyPress (event) {
    if (event.key === 'Enter') {
      event.preventDefault()
      this.handleSubmit()
    }
  }

  componentDidMount () {
    trackPageView('/change-password');
    this.startTime = Date.now();
    this.currentPath = window.location.href;
    var loginCheck = JSON.parse(localStorage.getItem('userInfo'))
    // console.log('loginCheck', loginCheck)
    if (loginCheck) {
      this.setState({ userInfo: loginCheck })
    }
  }

   componentWillUnmount() {
      trackTimeSpent('/change-password', this.currentPath, this.startTime);
  }

  render () {
    return (
      <div id='chg-form'>
        <div className='chg-outer-blk noselect'>
          <div className='chg-blk'>
            <div className='title-blk'>
              <p className='chg-title'>Change Password</p>
            </div>
            <div className='vertical-field-group'>
              <div className='label-input'>
                <label>current password*</label>
                <br />
                <input type={this.state.currentPwdType} autoComplete='off' name='currentPwd' id='currentPwd' placeholder='Enter current password' value={this.state.currentPwd} onChange={this.handleInputChange} onKeyPress={this.handleSubmitKeyPress} onFocus={() => this.handleFocus('currentPwd')} onBlur={() => this.handleBlur('currentPwd')} />
                <span className='pwdShow' onClick={() => this.handlePwdShowHide('currentPwdType', this.state.currentPwdType)}>
                  {this.state.currentPwdType === 'text'
                    ? <img src={process.env.PUBLIC_URL + '/assets/images/icons/ic_hidden.svg'} className='show-hide-icon' alt='eye' />
                    : <img src={process.env.PUBLIC_URL + '/assets/images/icons/ic_show.svg'} className='show-hide-icon' alt='eye' />
                  }
                </span>
              </div>
            </div>
            <div className='vertical-field-group'>
              <div className='label-input'>
                <label>new password*</label>
                <br />
                <input type={this.state.newPwdType} autoComplete='off' name='newPwd' id='newPwd' placeholder='Enter new password' value={this.state.newPwd} onChange={this.handleInputChange} onKeyPress={this.handleSubmitKeyPress} onFocus={() => this.handleFocus('newPwd')} onBlur={() => this.handleBlur('newPwd')} />
                <span className='pwdShow' onClick={() => this.handlePwdShowHide('newPwdType', this.state.newPwdType)}>
                  {this.state.newPwdType === 'text'
                    ? <img src={process.env.PUBLIC_URL + '/assets/images/icons/ic_hidden.svg'} className='show-hide-icon' alt='eye' />
                    : <img src={process.env.PUBLIC_URL + '/assets/images/icons/ic_show.svg'} className='show-hide-icon' alt='eye' />
                  }
                </span>
              </div>
            </div>
            <div className='vertical-field-group'>
              <div className='label-input'>
                <label>confirm password*</label>
                <br />
                <input type={this.state.confirmPwdType} autoComplete='off' name='confirmPwd' id='confirmPwd' placeholder='Re-enter password' value={this.state.confirmPwd} onChange={this.handleInputChange} onKeyPress={this.handleSubmitKeyPress} onFocus={() => this.handleFocus('confirmPwd')} onBlur={() => this.handleBlur('confirmPwd')} />
                <span className='pwdShow' onClick={() => this.handlePwdShowHide('confirmPwdType', this.state.confirmPwdType)}>
                  {this.state.confirmPwdType === 'text'
                    ? <img src={process.env.PUBLIC_URL + '/assets/images/icons/ic_hidden.svg'} className='show-hide-icon' alt='eye' />
                    : <img src={process.env.PUBLIC_URL + '/assets/images/icons/ic_show.svg'} className='show-hide-icon' alt='eye' />
                  }
                </span>
              </div>
            </div>
            <div className='bottom-section'>
              <div className='cancel-blk' onClick={this.props.hideOverlay}>
                <p className='cancel-btn'>Cancel</p>
              </div>
              <div className='submit-blk' onClick={this.handleSubmit}>
                <p className='submit-btn'>change password</p>
              </div>
            </div>
          </div>
        </div>
      </div>

    )
  }
}

export default ChangePassword
